import dayjs from 'dayjs';

import { EMPTY_VALUE } from './formatCurrency';

/**
 * Formata um instante em `DD/MM/YYYY HH:mm`.
 *
 * Usado onde a hora importa para o operador correlacionar eventos: NSU do
 * boleto, rastreabilidade e acompanhamento de pedido. Para datas de vencimento e
 * pagamento, use `formatContractDate`, que omite a hora.
 *
 * @param value - Data ISO vinda do backend; `null`/`undefined`/inválida retorna
 *   {@link EMPTY_VALUE}.
 *
 * @example
 * ```ts
 * formatDateTime('2026-03-14T12:30:00Z'); // '14/03/2026 12:30'
 * formatDateTime(null);                   // '—'
 * ```
 */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return EMPTY_VALUE;
  const date = dayjs(value);
  return date.isValid() ? date.format('DD/MM/YYYY HH:mm') : EMPTY_VALUE;
}
